module.exports = __webpack_public_path__ + "media/assets/img/flags/ko-KR-41f0f3705aa596b0f6962ea9399ee6dd.png";